export default function validateAccount(rule, value, callback) {
  if (value.trim() === '') {
    callback(new Error('请输入您的账号'))
  } else {
    if (!/^\w+$/.test(value.trim())) {
      callback(new Error('用户名为数字、字母、下划线组成'))
    } else {
      callback()
    }
  }
}
